module.exports = __webpack_public_path__ + "static/media/sortinghat.7a268413.jpeg";